import {
    BARRIER_INITIAL_SPAWN_INTERVAL_SEC,
    BARRIER_INITIAL_SPEED,
    BARRIER_MAX_SPEED,
    BARRIER_MIN_SPAWN_INTERVAL_SEC,
    SECONDARY_COLORS_UNLOCK_SCORE,
    SPAWN_INTERVAL_DROP_PER_POINT,
    SPEED_GAIN_PER_POINT,
} from "../config";
import { GameColor, PRIMARY_COLORS, SECONDARY_COLORS } from "../types";

export function barrierSpeedFor(score: number): number {
    return Math.min(BARRIER_INITIAL_SPEED + score * SPEED_GAIN_PER_POINT, BARRIER_MAX_SPEED);
}

export function spawnIntervalFor(score: number): number {
    return Math.max(
        BARRIER_INITIAL_SPAWN_INTERVAL_SEC - score * SPAWN_INTERVAL_DROP_PER_POINT,
        BARRIER_MIN_SPAWN_INTERVAL_SEC,
    );
}

/** Picks a barrier colour that differs from the previous one. Secondaries join the pool at higher scores. */
export function pickBarrierColor(
    score: number,
    previousColor: GameColor,
    choose: (options: GameColor[]) => GameColor,
): GameColor {
    const pool: GameColor[] =
        score < SECONDARY_COLORS_UNLOCK_SCORE
            ? [...PRIMARY_COLORS]
            : [...PRIMARY_COLORS, ...SECONDARY_COLORS];
    return choose(pool.filter((c) => c !== previousColor));
}
